import { useEffect, useState } from "react"
import { BasicPage } from "../../../../theme/Component/BasicPage"
import { ImportUBLInvoice } from "./ImportUBLInvoice";
import { CreateUBLInvoice } from "./CreateUBLInvoice/CreateUBLInvoice";
import { SearchUBLInovice } from "./CreateUBLInvoice/SearchUBLInovice";
import { CreateUBLInvoiceNote } from "./CreateUBLInvoice/CreateUBLInvoiceNote";
import { CreateUBLInvoiceSupplier } from "./CreateUBLInvoice/CreateUBLInvoiceSupplier";

type UBLInvoiceMenuOption =
    | "sale"
    | "supplier"
    | "creditNote"
    | "debitNote"
    | "import"
    | "importContainer"
    | "search";

interface Props {
    _onChange?: Function;
    idAccount?: number;
    _entry?: "Accounting" | "CashReimbursement";
    catalog?: boolean;
    cashReimbuisement?: boolean;
    menuOptions?: UBLInvoiceMenuOption[];
    importTypeDocument?: "sell" | "Supplier" | "None";
}

const menuCards: Record<UBLInvoiceMenuOption, any> = {
    sale: { id: 1, name: "Crear Factura de Venta", descripcion: "Crear documento electronico de venta", boton: "Entrar" },
    creditNote: { id: 2, name: "Crear Nota Credito de Factura", descripcion: "Crear documento electronico de nota credito", boton: "Entrar" },
    debitNote: { id: 3, name: "Crear Nota Debito de Factura", descripcion: "Crear documento electronico de nota debito", boton: "Entrar" },
    supplier: { id: 4, name: "Crear Factura de Proveedor", descripcion: "Crear factura de proveedor", boton: "Entrar" },
    import: { id: 5, name: "Importar Factura Electronica", descripcion: "Documento electronico y representacion PDF", boton: "Entrar" },
    importContainer: { id: 6, name: "Importar Contenedor de Facturas Electronicas", descripcion: "Importa y procesa multiples facturas", boton: "Entrar" },
    search: { id: 7, name: "Consultar Facturas", descripcion: "Consultar facturas por proveedor", boton: "Entrar" },
};

const buildCards = (options: UBLInvoiceMenuOption[]) => options.map((option) => menuCards[option]);

export const MakeUBLInvoice = ({
    _onChange,
    idAccount,
    _entry = "Accounting",
    catalog,
    cashReimbuisement,
    menuOptions,
    importTypeDocument = "None",
}: Props) => {
    const [step, setStep] = useState<any>({});
    const [card, setCard] = useState<any[]>(buildCards(["sale", "creditNote", "debitNote", "import", "search"]));

    useEffect(() => {
        if (menuOptions?.length) {
            setCard(buildCards(menuOptions));
        }
    }, [menuOptions])

    useEffect(() => {
        if (!menuOptions?.length && catalog) {
            setCard([
                { ...menuCards.sale, name: "Crear Factura Electronica", descripcion: "Crear documento" },
                menuCards.import,
                menuCards.creditNote,
                menuCards.debitNote,
            ])
        }
    }, [catalog, menuOptions])

    useEffect(() => {
        if (!menuOptions?.length && cashReimbuisement) {
            setCard([
                { ...menuCards.sale, name: "Crear Factura Electronica", descripcion: "Crear documento" },
                menuCards.import,
            ])
        }
    }, [cashReimbuisement, menuOptions])

    useEffect(() => {
        setStep({ id: 0, name: "" });
    }, [])

    return (
        <div className="row">
            <div className="col-md-12">
                <h6>Opciones de factura electronica</h6>
                <hr />
                 <div className="row">
                {step.id > 0 &&
                    <div className="col-md-6">
                        <div className="d-flex justify-content-around">
                            <div>
                                <h5>{step.name}</h5>
                            </div>
                            <div>
                                <a href="javascript:void(0)" className="btn btn-primary btn-sm" onClick={() => { setStep({ id: 0 }) }}>Regresar</a>
                            </div>
                        </div>
                        <hr />
                    </div>
                }
            </div>

            {step.id == 0 &&
                <div className="row">
                    {card.map((item: any) => (
                        <div className=" col-md-6" key={item.id}>
                            <div className="card card-body">
                                <div className="flex-grow-1 ms-2">
                                    <h5>{item.name}</h5>
                                    <p>{item.descripcion}</p>
                                    <a href="javascript:void(0)" className="btn btn-primary btn-sm" onClick={() => { setStep(item) }}>{item.boton}</a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }

            {step.id === 1 &&
                <CreateUBLInvoice typeDocument="sell" _idAccount={idAccount} _onChange2={_onChange} _entry={_entry} />
            }

            {step.id === 2 &&
                <CreateUBLInvoiceNote entry="Credit" _onChange2={_onChange} />
            }

            {step.id === 3 &&
                <CreateUBLInvoiceNote entry="Debit" _onChange2={_onChange} />
            }

            {step.id === 4 &&
                <CreateUBLInvoiceSupplier _onChange2={_onChange} />
            }

            {step.id === 5 &&
                // <ImportUBLInvoice _onChange2={_onChange} entry={_entry} typeDocument={importTypeDocument} />
                <ImportUBLInvoice _multipleUBLs={true} _onChange2={_onChange} entry={_entry} typeDocument={importTypeDocument}  />
            }

            {step.id === 6 &&
                <ImportUBLInvoice _multipleUBLs={true} _onChange2={_onChange} entry={_entry} typeDocument={importTypeDocument} />
            }

            {step.id === 7 &&
                <SearchUBLInovice _idAccount={idAccount} _onChange2={_onChange} />
            }
            </div>
        </div>
    )
}
